module.exports = __webpack_public_path__ + "img/practice_team.6e9781ab.svg";